<template>
	<div style="display: flex; flex-direction: column; flex-grow: 1">
		<v-form ref="form" style="flex-grow: 1">
			<v-row>
				<v-col cols="5">
					<v-text-field
						label="Name"
						:rules="nameRules"
						v-model="activity.Name"
					/>
				</v-col>
				<v-col cols="5">
					<v-select
						:disabled="this.$route.params.id != null"
						label="Entity"
						:items="entities"
						v-model="activity.GridViewId"
						:rules="entityRules"
						item-text="Name"
						item-value="Id"
					/>
				</v-col>
				<v-col
					><v-checkbox label="Active" v-model="activity.IsVisible"
				/></v-col>
			</v-row>
			<v-card v-if="this.$route.params.id">
				<v-card-title> Manage group by criteria </v-card-title>
				<v-card-text>
					<v-container fluid class="py-6">
						<v-row>
							<div style="flex-grow: 1">
								<v-text-field
									class="py-0 my-0 mb-2 mr-2"
									v-model="search"
									label="Search"
								></v-text-field>
							</div>
							<div>
								<v-btn class="primary" @click="onAdd()">
									<v-icon> mdi-plus</v-icon>
									&nbsp;&nbsp;Add</v-btn
								>
							</div>
						</v-row>
					</v-container>
					<v-row>
						<v-col>
							<v-data-table
								:headers="headers"
								:items="conditionFieldsList"
								dense
								:search.sync="search"
							>
								<template v-slot:[`item.Fields`]="{ item }">
									<v-chip-group>
										<v-chip
											dense
											small
											v-for="(
												gvf, index
											) in item.GridViewFieldIds"
											:key="index"
										>
											{{ getGridViewFieldName(gvf) }}
										</v-chip>
									</v-chip-group>
								</template>
								<template v-slot:[`item.actions`]="{ item }">
									<div class="d-flex">
										<v-spacer />
										<v-btn
											class="action-btn"
											fab
											small
											icon
											elevation="1"
											color="success"
											@click="editItem(item)"
										>
											<v-icon small> mdi-pencil </v-icon>
										</v-btn>
										<v-btn
											class="action-btn"
											fab
											small
											icon
											elevation="1"
											color="error"
											@click="deleteItem(item.Id)"
										>
											<v-icon small> mdi-delete</v-icon>
										</v-btn>
									</div>
								</template>
							</v-data-table>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-form>
		<div style="align-self: flex-end">
			<v-btn class="primary" @click="submit()"> Submit </v-btn>
		</div>
		<ActivityConditionFieldsModal
			v-if="selectedItem"
			:showDialog="showDialog"
			:selectedItem="selectedItem"
			@close="closeItemModal()"
		/>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import {
	ActivityDetailsActions,
	ActivityActions,
} from '../../../../store/actions';
import { ActivityDetailsGetters } from '../../../../store/getters';
import ActivityConditionFieldsModal from './ActivityConditionFieldsModal.vue';
import ConfirmDialog from '@/components/core/dialogs/confirmDialog';
import permissionsMixin from '../../../../mixins/permissionsMixin';
import { Permissions } from '../../../../enums/permissionsEnum';
export default {
	name: 'ActivityDetails',
	components: { ActivityConditionFieldsModal },
	mixins: [permissionsMixin],
	data() {
		return {
			search: '',
			selectedItem: null,
			showDialog: false,
			nameRules: [(v) => !!v || 'Name is required'],
			entityRules: [(v) => !!v || 'Entity is required'],
			headers: [
				{
					text: 'Label',
					value: 'Label',
				},
				{
					text: 'Fields',
					value: 'Fields',
				},
				{
					test: '',
					value: 'actions',
				},
			],
		};
	},
	computed: {
		...mapGetters({
			entities: [ActivityDetailsGetters.ENTITIES],
			selectedActivity: [ActivityDetailsGetters.SELECTED_ACTIVITY],
			gridViewFields: [ActivityDetailsGetters.GRID_VIEW_FIELDS],
			conditionFieldsList: [ActivityDetailsGetters.CONDITION_FIELDS_LIST],
			hasItems: [ActivityDetailsGetters.HAS_ITEMS],
		}),
		activity() {
			return Object.assign({}, this.selectedActivity);
		},
		canView() {
			return this.hasPermissions([
				Permissions.Tools.ActivityBuilder.View,
			]);
		},
		canAdd() {
			return this.hasPermissions([Permissions.Tools.ActivityBuilder.Add]);
		},
		canEdit() {
			return this.hasPermissions([
				Permissions.Tools.ActivityBuilder.Edit,
			]);
		},
		canDelete() {
			return this.hasPermissions([
				Permissions.Tools.ActivityBuilder.Delete,
			]);
		},
	},
	mounted() {
		this.$store.dispatch(
			ActivityDetailsActions.LOAD,
			this.$route.params.id
		);
	},
	destroyed() {
		this.$store.dispatch(ActivityDetailsActions.CLEAR);
	},
	methods: {
		getGridViewFieldName(gvfId) {
			if (!this.gridViewFields) return null;
			return this.gridViewFields.find((x) => x.Id == gvfId).Label;
		},
		closeItemModal() {
			this.showDialog = false;
			this.selectedItem = null;
		},
		onAdd() {
			this.selectedItem = { ActivityId: this.$route.params.id };
			this.showDialog = true;
		},
		submit() {
			if (this.$route.params.id) {
				this.$store.dispatch(
					ActivityDetailsActions.UPDATE_ACTIVITY,
					this.activity
				);
			} else {
				this.$store
					.dispatch(
						ActivityDetailsActions.INSERT_ACTIVITY,
						this.activity
					)
					.then((success) => {
						if (!success) return;
						this.$store.dispatch(ActivityActions.LOAD_ACTIVITIES);
						this.$store.dispatch(
							ActivityDetailsActions.LOAD_GRID_VIEW_FIELDS,
							this.activity.Id
						);
						this.$router.push({
							name: 'EditActivity',
							params: { id: this.activity.Id },
						});
					});
			}
		},
		editItem(item) {
			this.selectedItem = item;
			this.showDialog = true;
		},
		deleteItem(id) {
			if (this.hasItems) {
				ConfirmDialog({
					message:
						'Already created items will be deleted if group by criteria is modified. Do you want to continue?',
				}).then((isDelete) => {
					if (isDelete) {
						this.$store.dispatch(
							ActivityDetailsActions.DELETE_ALL_ACTIVITY_ITEMS_BY_ID,
							this.$route.params.id
						);
						this.$store.dispatch(ActivityDetailsActions.DELETE, id);
					}
				});
			} else {
				ConfirmDialog({
					message: 'Are you sure you want to delete this list?',
				}).then((isDelete) => {
					if (isDelete) {
						this.$store.dispatch(ActivityDetailsActions.DELETE, id);
					}
				});
			}
		},
	},
};
</script>
